import PropTypes from 'prop-types';
import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap/lib';

const propTypes = {
  sections: PropTypes.arrayOf(PropTypes.array),
  headers: PropTypes.arrayOf(PropTypes.string),
  links: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.string,
  selectedProp: PropTypes.string,
  selectedValue: PropTypes.any,
  displayProp: PropTypes.string,
  showSelectedValue: PropTypes.bool,
  onSelect: PropTypes.func,
  history: PropTypes.object,
  emptyDataProp: PropTypes.string,
  truncateSelection: PropTypes.bool,
  disabled: PropTypes.bool,
  matchId: PropTypes.number,
  sourceMapId: PropTypes.number
};

const defaultProps = {
  truncateSelection: true,
  disabled: false
};

const EVENT_KEY_LINK = 'LINK';

const SurveyListSelect = props => {
  const {
    label,
    selectedProp,
    displayProp,
    selectedValue,
    onSelect,
    showSelectedValue,
    history,
    sections,
    emptyDataProp,
    truncateSelection,
    disabled,
    matchId,
    sourceMapId
  } = props;

  const items = buildSections(props);

  const selectedItem = items.find(item => item[selectedProp] === selectedValue);

  let displayValue = selectedItem ? selectedItem[displayProp] : null;

  if (truncateSelection) {
    displayValue = displayValue ? displayValue.slice(0, 33) : null;
    if (displayValue && displayValue.length > 32) displayValue += '...';
  }

  if (!displayValue) displayValue = 'No selection';

  if (!hasSelectionItems(sections)) displayValue = 'No cuts available';

  const labelSpan =
    label && showSelectedValue ? <span className="surveyListSelect-dropdown-label">{label}</span> : null;

  const onSelectHandler = (...args) => {
    const eventKey = args[0];
    if (eventKey && eventKey === EVENT_KEY_LINK) {
      //  do not do selection handler for links as they can trigger their own actions
      return;
    }

    onSelect(...args, selectedItem, items, matchId, sourceMapId);
  };

  return (
    <div className="survey-list-select">
      {labelSpan}
      <DropdownButton
        title={showSelectedValue ? <span className="survey-list-select__selection">{displayValue}</span> : label}
        className="survey-list-select__dropdown"
        id="surveyListSelect-dropdown"
        onSelect={onSelectHandler}
        disabled={disabled}
      >
        {items.map((item, index) => {
          if (item.$$typeof) return item; // is a component
          const itemValue = item[selectedProp];
          const greenCheck = itemValue === selectedValue ? <i className="icon-check" aria-hidden="true" /> : '';
          if (!item[emptyDataProp]) {
            return (
              <MenuItem eventKey={itemValue} key={`${itemValue}-${index}`} id={itemValue}>
                {greenCheck}
                {item[displayProp]}
              </MenuItem>
            );
          } else {
            return (
              <MenuItem disabled eventKey={itemValue} key={`${itemValue}-${index}`} id={itemValue}>
                {item[displayProp]}
              </MenuItem>
            );
          }
        })}
      </DropdownButton>
    </div>
  );
};

const hasSelectionItems = sections => {
  let hasItems = false;
  if (sections) {
    sections.forEach(section => {
      if (section) section.forEach(item => (hasItems = true));
    });
  }
  return hasItems;
};

const buildSections = props => {
  const { sections, headers, links, emptyTexts, history } = props;

  return sections.reduce((acc, list, index) => {
    const header = headers[index];
    const link = links[index];
    const emptyText = emptyTexts[index];

    if (index && list && list.length) {
      acc.push(<MenuItem divider key={'divider' + index} />);
    }

    if (header && list && list.length) {
      acc.push(
        <MenuItem header className="surveyListSelect--header" key={header}>
          {header}
        </MenuItem>
      );
    } else if (emptyText) {
      acc.push(
        <MenuItem header key={emptyText}>
          {emptyText}
        </MenuItem>
      );
    }

    if (list.length) acc = acc.concat(list); // eslint-disable-line

    if (link) {
      const onClick = link.action ? link.action : () => history.push(link.route);
      acc.push(
        <MenuItem className="surveyListSelect--link" onClick={onClick} key={link.text} eventKey={EVENT_KEY_LINK}>
          {link.text}
        </MenuItem>
      );
    }

    return acc;
  }, []);
};

SurveyListSelect.defaultProps = defaultProps;
SurveyListSelect.propTypes = propTypes;

export default SurveyListSelect;
